import React from 'react';
import PropTypes from 'prop-types';
import Bem from '../packages/honey-bem.js';
import { Injecss } from '../packages/injecss.js';

var styles = {
raw: ".hcr-table__wrap-1-6-0{display:inline-block;margin-bottom:12px;padding:12px 0;border:1px solid #e1e1e1;border-radius:5px}.hcr-table-1-6-0{border-collapse:separate;border-spacing:24px 0}.hcr-table__header-1-6-0 td,.hcr-table__header-1-6-0 th{color:#444;font-size:16px;font-weight:700;line-height:22px}.hcr-table-1-6-0 tr:last-child td{border-bottom:0}.hcr-table-1-6-0 td,.hcr-table__header-1-6-0 td,.hcr-table__header-1-6-0 th{padding:12px 0;border-bottom:1px solid #e1e1e1;text-align:left}",
map:{"hcr-table__wrap":"hcr-table__wrap-1-6-0","hcr-table":"hcr-table-1-6-0","hcr-table__header":"hcr-table__header-1-6-0"}};

var bem = Bem('table', styles);
var Table = function Table(_ref) {
  var headers = _ref.headers,
      rows = _ref.rows,
      extraClasses = _ref.extraClasses;
  return React.createElement("div", {
    className: bem.e('wrap', false, extraClasses)
  }, React.createElement("table", {
    className: bem.b()
  }, React.createElement("tbody", null, headers && React.createElement("tr", {
    className: bem.e('header')
  }, headers.map(function (header, i) {
    return React.createElement("td", {
      key: i
    }, header);
  })), rows.map(function (row, i) {
    return React.createElement("tr", {
      key: i
    }, row.map(function (content, y) {
      return React.createElement("td", {
        key: i + y
      }, content);
    }));
  }))));
};
Table.displayName = 'Table';
Table.defaultProps = {
  headers: false,
  extraClasses: ''
};
Table.propTypes = {
  /** Table headers as one dimensional array */
  headers: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.number])),

  /** Table rows as multidimensional array (with nested columns) */
  rows: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.number]))).isRequired,

  /** Injection in className */
  extraClasses: PropTypes.string
};
var table = Injecss(Table, styles);

export { table as Table };
